import { render } from "./Collapsible.vue?vue&type=template&id=6b0eb920"
import script from "./Collapsible.vue?vue&type=script&lang=ts"
export * from "./Collapsible.vue?vue&type=script&lang=ts"

import "./Collapsible.vue?vue&type=style&index=0&id=6b0eb920&lang=scss"
script.render = render

export default script